import {mapGetters} from 'vuex'
import Util from '@/util'

export default {
  computed: {
    ...mapGetters(['getUserProfile', 'getConfig']),
    logzioToken() {
      return this.getConfig && typeof this.getConfig === 'function'
        ? this.getConfig('LOGZIO_TOKEN')
        : null
    },
  },
  data() {
    return {
      logger: null,
    }
  },
  async mounted() {  
    if (!this.logzioToken && this.getUserProfile && this.getUserProfile.id) {
      await this.$store.dispatch('fetchConfig')
    }
    this.initLogger()
  },
  methods: {
    initLogger() {
      // noop: analytics events are sent directly to Logz.io via eventTransmitter;
      // keep method for compatibility with existing components
      this.logger = {
        log: () => {}
      }
    },
    /**
     * Get browser name and version
     * @returns {string}
     */
    browser() {
      const {browser: browserInfo} = Util.getDeviceAndBrowserInfo();
      return `${browserInfo.name} ${browserInfo.version}`;
    },
    async log(data) {
      const {id, email} = this.getUserProfile
      const normalized = Object.assign({}, data)
      if (!normalized.eventName) {
        const { ANALYTICS_EVENTS } = require('@/util/constants')
        normalized.eventName = ANALYTICS_EVENTS.FE_ACTIVITY
      }
      const payload = {
        browser: this.browser(),
        user: {id, email},
        ...normalized,
      }
      try {
        const { EVENT_PROVIDERS } = require('@/util/constants')
        const { sendEvent } = require('@/mixins/eventTransmitter')
        await sendEvent([EVENT_PROVIDERS.LOGZIO], payload, this.$store)
      } catch (e) {
        // ignore
      }
    },
  },
  watch: {
    logzioToken() {
      // (re)initialize as soon as token becomes available
      this.initLogger()
    }
  }
}
